import { render, staticRenderFns } from "./NewDocumentDialog.vue?vue&type=template&id=b49972f2&scoped=true&"
import script from "./NewDocumentDialog.vue?vue&type=script&lang=ts&"
export * from "./NewDocumentDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NewDocumentDialog.vue?vue&type=style&index=0&id=b49972f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49972f2",
  null
  
)

export default component.exports